export const isStringNullOrEmpty = (value: string | null) => {
  if (!value) return true;
  return value.trim() === "";
};
